/**
 * @generated SignedSource<<fd6079c7ee8f70ec4e8be37b2b1665fc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueBody$data = {
  readonly author: {
    readonly " $fragmentSpreads": FragmentRefs<"IssueBodyHeaderAuthor">;
  } | null;
  readonly createdAt: string;
  readonly databaseId: number | null;
  readonly id: string;
  readonly locked: boolean;
  readonly number: number;
  readonly repository: {
    readonly databaseId: number | null;
    readonly id: string;
    readonly nameWithOwner: string;
    readonly slashCommandsEnabled: boolean;
  };
  readonly title: string;
  readonly viewerCanUpdateNext: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"IssueBodyContent" | "MarkdownEditHistoryViewer_comment" | "ReactionViewerGroups">;
  readonly " $fragmentType": "IssueBody";
};
export type IssueBody$key = {
  readonly " $data"?: IssueBody$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueBody">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueBody",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "IssueBodyHeaderAuthor"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameWithOwner",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slashCommandsEnabled",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanUpdateNext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locked",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReactionViewerGroups"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IssueBodyContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MarkdownEditHistoryViewer_comment"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};
})();

(node as any).hash = "15789b4a5f2cf4a8e9b1ba34f83d7f8c";

export default node;
